import React, { useEffect, useMemo, useState } from "react";
import ReactTable from "react-table";
import { currencyFormater, mustBeArray } from "../../utils/lib";
import _ from "lodash-es";
import { Input } from "reactstrap";
import { Link } from "react-router-dom";
import { BASE_URL } from "../../constants";

/**
 * @typedef ForInvoiceItem
 * @property {number} id
 * @property {string} clientLocation
 * @property {number} totalLitersOil
 * @property {number} costPerLiter
 * @property {number} totalAmount
 * @property {number} gst
 * @property {number} subTotal
 */


/**
 * @typedef MYOBInvoiceListProps
 * @property {ForInvoiceItem[]} rows
 * 
 * @param {MYOBInvoiceListProps} Props 
 * @returns 
 */
const MYOBInvoiceList = ({
  onRowSelectionChanged,
  detailView,
  rows = [],
  showGstAndSubTotal,
  searching = false
}) => {

  const [selectedRows, setSelectedRows] = useState([]);
  const allSelected = useMemo(() => selectedRows.length === rows.length, [selectedRows, rows]);

  useEffect(() => {
    if (onRowSelectionChanged) {
      onRowSelectionChanged(selectedRows)
    }
  }, [selectedRows]);

  const onSelectAll = () => {
    if (allSelected) {
      setSelectedRows([]);
    } else {
      setSelectedRows(rows.map(x => x.id));
    }
  }

  const onRowSelect = (row) => {
    if (selectedRows.includes(row.id)) {
      setSelectedRows(selectedRows.filter(x => x !== row.id));
    } else {
      setSelectedRows([...selectedRows, row.id]);
    }
  };

  let getColumns = () => {
    let columns = _.concat(
      detailView
        ? []
        : [
          {
            id: "selected",
            accessor: (x) => x.selected,
            Header: (
              <div className="flex justify-content-center pl-1 selectableRowCheckbox">
                <Input
                  type="checkbox"
                  onChange={onSelectAll}
                  checked={allSelected}
                  disabled={_.isEmpty(rows)}
                />
              </div>
            ),
            maxWidth: 60,
            sortable: false,
            Cell: (row) => (
              <div className="flex justify-content-center pl-1 selectableRowCheckbox">
                <Input
                  type="checkbox"
                  onChange={() => onRowSelect(row.original)}
                  checked={selectedRows.includes(
                    row.original.id
                  )}
                  disabled={false}
                />
              </div>
            ),
          },
        ],
      [
        {
          id: "location",
          Header: "Client Location",
          accessor: (x) => x.locationName,
          Cell: (row) => (
            <Link
              target="_blank"
              to={`${BASE_URL}/manage/locations/${row.original.locationId}`}
            >
              {row.original.clientLocation}
            </Link>
          ),
        },
        {
          id: "totalLitersOil",
          Header: "Total Litres of Oil",
          accessor: (x) => x.totalLitersOil,
          Cell: (row) => <div className="text-right">{row.value}</div>,
        },
        {
          id: "costPerLiter",
          Header: "Cost per Litre",
          accessor: (x) => x.costPerLiter,
          Cell: (row) => (
            <div className="text-right">{currencyFormater(row.value)}</div>
          ),
        },
        {
          id: "totalAmount",
          Header: "Total Amount",
          accessor: (x) => x.totalAmount,
          Cell: (row) => (
            <div className="text-right">{currencyFormater(row.value)}</div>
          ),
        },
      ]
    );
    if (showGstAndSubTotal) {
      columns = [
        ...columns,
        {
          id: "gst",
          Header: "GST",
          accessor: (x) => x.gst,
          Cell: (row) => (
            <div className="text-right">{currencyFormater(row.value)}</div>
          ),
        },
        {
          id: "subTotal",
          Header: "Sub Total",
          accessor: (x) => x.subTotalAmount,
          Cell: (row) => (
            <div className="text-right">{currencyFormater(row.value)}</div>
          ),
        },
      ];
    }
    return columns;
  };
  return (
    <ReactTable
      sortable
      filterable={false}
      showPagination={true}
      loading={searching}
      defaultPageSize={20}
      data={rows}
      columns={getColumns()}
      minRows={
        mustBeArray(rows).length === 0
          ? 5
          : mustBeArray(rows).length > 20
            ? 20
            : mustBeArray(rows).length
      }
      className="selectableRowTable"
    />
  );
};
export default MYOBInvoiceList;
